export const getApiErrors = (error: any): Record<string, string> => {
    const data = error?.response?.data;
    const status = error?.response?.status;

    // FastAPI field-level errors object: { errors: { field: "msg" } }
    if (data?.errors && typeof data.errors === 'object') {
        return data.errors as Record<string, string>;
    }

    // FastAPI 422 validation errors: { detail: [{ loc: [...], msg: "...", type: "..." }] }
    if (Array.isArray(data?.detail)) {
        const fieldErrors: Record<string, string> = {};
        for (const err of data.detail) {
            // loc is e.g. ["body", "email"] or ["body", "guardians", 0, "email"]
            // Skip the "body" prefix and join the rest with dots
            const parts = (err.loc || []).filter((p: any) => p !== 'body');
            const field = parts.join('.');
            if (field) {
                fieldErrors[field] = err.msg;
            }
        }
        if (Object.keys(fieldErrors).length > 0) return fieldErrors;
        return { _global: data.detail[0]?.msg || 'Validation error' };
    }

    // Structured field errors: { detail: { field: "msg", ... } }
    if (data?.detail && typeof data.detail === 'object' && !Array.isArray(data.detail)) {
        return data.detail as Record<string, string>;
    }

    // FastAPI string detail: { detail: "Teacher limit reached" }
    if (typeof data?.detail === 'string') {
        return { _global: data.detail };
    }

    // Generic error message from response
    if (typeof data?.message === 'string') {
        return { _global: data.message };
    }

    if (status >= 500) {
        return { _global: 'The server could not complete this request. Please try again.' };
    }

    return {
        _global: 'An unexpected error occurred. Please try again.',
    };
};
